import EntryHierarchy from '@wielink-application/shared/js/base/menu/EntryHierarchy';
export default EntryHierarchy;